module.exports = __webpack_public_path__ + "img/divide-02.f00c3cab.svg";